// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RMxz","content":"styles_content__2jJd6"};